export default "__VITE_ASSET__a4a8d04e__"